module.exports = __webpack_public_path__ + "static/media/Seobix.b64ed0f8.svg";